import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { LoggingService } from '../logging.service';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

const identityServer    = environment.identityServer;
const authHeaderClient  = environment.authHeaderClient;

@Injectable()
export class AuthenticationService {

  constructor(
    private client: HttpClient,
    private loggingService: LoggingService
  ) { }

  attemptAuth(ussername: string, password: string): Observable<string> {
    const xid = this.loggingService.generateUUID();
    const qualName = 'App.Services.AuthenticationService.attemptAuth';
    
    this.loggingService.logStart(xid, qualName, null, 'Authentication attempt');
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': authHeaderClient
      })
    };
    const credentials = `username=${ussername}&password=${password}&grant_type=password`;
    
    return this.client.post<string>(`${identityServer}/connect/token`, credentials, httpOptions)
      .do(result => {
        this.loggingService.logFinish(xid, qualName, null, 'Authentication successful');
      })
      .catch(error => {
        this.loggingService.logError(xid, qualName, error, null, 'Authentication failed');
        return Observable.throw(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth/authentication.service.ts